/**
 * 本地資料庫
 * 列表 - 查詢條件保留
 *
 * 以 route.name 為 key，保存各列表頁的查詢狀態，讓管理員
 * 「查詢 → 進內容頁 → 返回」或「跳其他功能頁再返回」時條件不被清空。
 *
 * - storage 用 sessionStorage：只存活於本次登入 / 本瀏覽器分頁。
 * - 寫入者只有 TwDataTable (fetch 成功後)。
 * - 清除者有兩個：TwDataTable 的「重設」按鈕 (單一頁)、AuthStore.setLogin (全部)。
 *
 * @since 2026-08-09
 */

import {defineStore} from "pinia";
import {PiniaEnum} from "@/v2/enumerate/pinia";
import PiniaPersistSessionConfiguration from "@/v2/configuration/pinia/session";

/**
 * 單一列表頁保留的查詢狀態
 */
























export const FilterStore = defineStore({
    id: PiniaEnum.FILTER,
    state: () => ({
        entries: {}
    }),
    actions: {
        //取出指定列表頁的查詢狀態 (沒有則回 null)
        get(key) {
            return this.entries[key] ?? null
        },
        //寫入指定列表頁的查詢狀態
        set(key, entry) {
            this.entries[key] = entry
        },
        //移除指定列表頁 (使用者按「重設」)
        remove(key) {
            delete this.entries[key]
        },
        //全部清空 (身分變動：登入 / 登出 / 逾時 / 模擬登入 / 回總會)
        clear() {
            this.entries = {}
        }
    },
    persist: PiniaPersistSessionConfiguration(PiniaEnum.FILTER)
});
